import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  width: '100%',
  backgroundColor: '#f5f7fa',
}));

const MainContent = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingBottom: theme.spacing(0),
}));

const Layout = ({ children }) => {
  const location = useLocation();
  const hideFooter = location.pathname === '/widget-generator';
  return (
    <LayoutContainer>
      <MainContent>
        {children}
      </MainContent>
      {!hideFooter && <Footer />}
    </LayoutContainer>
  );
};

export default Layout; 